import createPermission from 'permissions/createPermission'

export const view = createPermission('unit.videoOnDemand.view')
export const request = createPermission('unit.videoOnDemand.request')
export const exports = createPermission('unit.videoOnDemand.export')